export const SegmentEvents = {
  mapLayerPropertiesOpen: 'Map Layer Properties',
  mapLayerRetailersOpen: 'Map Layer Retailers',
  mapLayerDemographicsOpen: 'Map Layer Demographics',
  mapLayerOverlaysOpen: 'Map Layer Overlays',
  mapLayerPlacesOpen: 'Map Layer Places',
  mapLayerMeasureOpen: 'Map Layer Measure',
  mapLayerTrafficClick: 'Map Layer Traffic'
};



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/constants/SegmentEvents.ts